import React, {useState, useEffect} from 'react';
import menu from '../resources/icons/menu.png';
import cross from '../resources/icons/cross.png';
import logo from '../resources/icons/logo32.png';
import SideBar from './layout/sidebar';
import SideBarMobile from './layout/sidebarMobile';
// import TwitterPopup from './layout/twitterPopup';
import "../css/header.css";


const Header = () =>{ 

    const [menuToggle, ToggleMenu] = useState(true);
    const [sidebarToggle, ToggleSidebar] = useState(true);
    
    if(window.innerWidth<750){
        let image = menu;
        let diaplayMenu = "0px";
        let height = "0px";
        if(!menuToggle){
            image = cross;
            height = "170px";
            diaplayMenu = "100px";
        } else{
            image = menu;
        }

        return(
            <div>
                <div className="header" style={{textAlign: "right"}}>
                    

                    <div className='menu-header-div'>
                        
                        <div className='header-logo-div'>
                            <img className='header-logo-div-img' src={logo} alt="Website Logo" />
                            <h2 className='header-logo-div-h2'>Planet Stat</h2>
                        </div>
                        <div className="menu-img-div">
                            <img className="menu-img" src={image} alt='Menu Option' onClick={() =>{
                                
                                ToggleMenu(!menuToggle)}}></img>
                        </div>
                        
                    </div> 
                    
                </div>
                <SideBarMobile menuToggle={menuToggle}/>
                
            </div>
        );
    }


    let image = menu;
        if(!menuToggle){
            image = cross;
        } else{
            image = menu;
        }
    
    return (
    <div className="header">
        
        
        <div className='header-logo-div-desktop'>
            <div className='sidebar-img-div'>
            <img src={image} alt="Sidebar Image" className="sidebar-img"  onClick={() =>{
                                
                                ToggleSidebar(!sidebarToggle)}}/> 
            </div>
        
        
                    <img className='header-logo-div-img' src={logo} alt="Website Logo" />
                    <h2 className='header-logo-div-h2' >Planet Stat</h2>
        </div>
        <ul style={{display: "inline-block"}}>
            <li><a href="/" className='header-tab'>Home</a></li>
            <li><a href="/country" className='header-tab'>Country</a></li>
            <li><a href="/world" className='header-tab' >World</a></li>
            <li><a href="/About" className='header-tab'>About</a></li>
        </ul>
        <SideBar menuToggle={sidebarToggle}/>
    </div>
);

}
export default Header;